import FileSaver from 'file-saver';
import { Auth } from '@mabinso-registry/module-commons';

class Download {
    /* constructor() {
    } */

    static do(options) {
        const req = new XMLHttpRequest();
        req.open(options.method || 'GET', options.url, true);
        req.setRequestHeader('X-Authorisation', Auth.getToken());
        req.addEventListener('progress', evt => {
            if (evt.lengthComputable) {
                const percentComplete = evt.loaded / evt.total;
                console.log(percentComplete);
            }
        }, false);
        req.responseType = 'blob';
        //
        req.onreadystatechange = () => {
            if (req.readyState === 4 && req.status === 200) {
                let { filename } = options;
                if (filename === undefined) {
                    const myHeader = req.getResponseHeader('Content-disposition');
                    ([, filename] = myHeader.split('='));
                    filename = filename.replace(/"/g, '').replace(/ /g, '');
                }
                // var blob = new Blob([req.response], {type: "application/pdf"});
                const blob = new Blob([req.response]);
                FileSaver.saveAs(blob, filename, false);
                if (options.success) {
                    options.success(filename);
                }
            } else if (req.readyState === 4) {
                const blob2 = new Blob([req.response]);
                const reader = new FileReader();
                reader.onload = () => {
                    options.error(JSON.parse(reader.result));
                };
                reader.readAsText(blob2);
            }
        };
        req.send();
    }
}

export default Download;
